
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class CsSizeGrid extends Serenity.EntityGrid<CsSizeRow, any> {
        protected getColumnsKey() { return CsSizeColumns.columnsKey; }
        protected getDialogType() { return CsSizeDialog; }
        protected getIdProperty() { return CsSizeRow.idProperty; }
        protected getInsertPermission() { return CsSizeRow.insertPermission; }
        protected getLocalTextPrefix() { return CsSizeRow.localTextPrefix; }
        protected getService() { return CsSizeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}